// @ts-expect-error moduleResolution:nodenext issue 54523
import { html } from 'lit';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { customElement, property } from 'lit/decorators.js';
import LightElement from './light-element.js';

@customElement('range-block')
export default class RangeBlock extends LightElement {

	@property({ type: String })
	productsURL: string = "";

	@property({ type: String })
	facetsURL: string = "";

	@property({ type: String })
	search: string = "all-radiators";

	@property({ type: String })
	initialFacets: string = "";

	@property({ type: Boolean })
	showZeroFilters: boolean = false;

	private firstLoad = true;

	updated(changedProperties: Map<string | number | symbol, unknown>) {
		if (!this.firstLoad && (changedProperties.has('search') || changedProperties.has('initialFacets'))) {
			this.dispatchRangeBlockEvent();
		}
	}

	connectedCallback() {
		super.connectedCallback();

		setTimeout(() => {
			this.firstLoad = false;
			this.dispatchRangeBlockEvent();
		}, 200);
	}

	private dispatchRangeBlockEvent() {
		const event = new CustomEvent('range-block-loaded', {
			detail: {
				search: this.search,
				initialFacets: this.initialFacets
			}
		});
		document.dispatchEvent(event);
	}

	private renderPlaceholderItems(count: number) {
		return Array.from({ length: count }, () => html`<div class="mFilter__placeholder-item"></div>`);
	}

	private renderFiltersPlaceholder() {
		if (this.showZeroFilters) {
			return html`
				<div class="mFilter mFilter--placeholder noPrint">
						<div class="inner clearfix ">
								<h3 class="c-accordion__heading"><button type="button" class="c-accordion__title js-slide-toggle" aria-controls="accordion-placeholder-needitfast-content" aria-expanded="false" data-transition-time="300" id="accordion-placeholder-needitfast" aria-hidden="true" tabindex="-1">Need it fast?</button></h3>
								<div class="c-accordion__content" id="accordion-placeholder-needitfast-content" aria-labelledby="accordion-placeholder-needitfast" aria-hidden="true">
									${this.renderPlaceholderItems(1)}
								</div>
						</div>
				</div>
				<div class="mFilter mFilter--placeholder noPrint">
						<div class="inner clearfix ">
								<h3 class="c-accordion__heading"><button type="button" class="c-accordion__title js-slide-toggle" aria-controls="accordion-placeholder-rating-content" aria-expanded="false" data-transition-time="300" id="accordion-placeholder-rating" aria-hidden="true" tabindex="-1">Avg. Customer Rating</button></h3>
								<div class="c-accordion__content" id="accordion-placeholder-rating-content" aria-labelledby="accordion-placeholder-rating" aria-hidden="true">
									${this.renderPlaceholderItems(5)}
								</div>
						</div>
				</div>
				<div class="mFilter mFilter--placeholder noPrint">
						<div class="inner clearfix ">
								<h3 class="c-accordion__heading"><button type="button" class="c-accordion__title js-slide-toggle" aria-controls="accordion-placeholder-type-content" aria-expanded="false" data-transition-time="300" id="accordion-placeholder-type" aria-hidden="true" tabindex="-1">Type</button></h3>
								<div class="c-accordion__content" id="accordion-placeholder-type-content" aria-labelledby="accordion-placeholder-type" aria-hidden="true">
									${this.renderPlaceholderItems(5)}
								</div>
						</div>
				</div>
				<div class="mFilter mFilter--placeholder noPrint">
						<div class="inner clearfix ">
								<h3 class="c-accordion__heading"><button type="button" class="c-accordion__title js-slide-toggle" aria-controls="accordion-placeholder-colour-content" aria-expanded="false" data-transition-time="300" id="accordion-placeholder-colour" aria-hidden="true" tabindex="-1">Colour</button></h3>
								<div class="c-accordion__content" id="accordion-placeholder-colour-content" aria-labelledby="accordion-placeholder-colour" aria-hidden="true">
									${this.renderPlaceholderItems(5)}
								</div>
						</div>
				</div>
				<div class="mFilter mFilter--placeholder noPrint">
						<div class="inner clearfix ">
								<h3 class="c-accordion__heading"><button type="button" class="c-accordion__title js-slide-toggle" aria-controls="accordion-placeholder-width-content" aria-expanded="false" data-transition-time="300" id="accordion-placeholder-width" aria-hidden="true" tabindex="-1">Width (mm)</button></h3>
								<div class="c-accordion__content" id="accordion-placeholder-width-content" aria-labelledby="accordion-placeholder-width" aria-hidden="true">
									${this.renderPlaceholderItems(5)}
								</div>
						</div>
				</div>
				<div class="mFilter mFilter--placeholder noPrint">
						<div class="inner clearfix ">
								<h3 class="c-accordion__heading"><button type="button" class="c-accordion__title js-slide-toggle" aria-controls="accordion-placeholder-height-content" aria-expanded="false" data-transition-time="300" id="accordion-placeholder-height" aria-hidden="true" tabindex="-1">Height (mm)</button></h3>
								<div class="c-accordion__content" id="accordion-placeholder-height-content" aria-labelledby="accordion-placeholder-height" aria-hidden="true">
									${this.renderPlaceholderItems(5)}
								</div>
						</div>
				</div>
				<div class="mFilter mFilter--placeholder noPrint">
						<div class="inner clearfix ">
								<h3 class="c-accordion__heading"><button type="button" class="c-accordion__title js-slide-toggle" aria-controls="accordion-placeholder-depth-content" aria-expanded="false" data-transition-time="300" id="accordion-placeholder-depth" aria-hidden="true" tabindex="-1">Depth (mm)</button></h3>
								<div class="c-accordion__content" id="accordion-placeholder-depth-content" aria-labelledby="accordion-placeholder-depth" aria-hidden="true">
									${this.renderPlaceholderItems(5)}
								</div>
						</div>
				</div>
				<div class="mFilter mFilter--placeholder noPrint">
						<div class="inner clearfix ">
								<h3 class="c-accordion__heading"><button type="button" class="c-accordion__title js-slide-toggle" aria-controls="accordion-placeholder-brand-content" aria-expanded="false" data-transition-time="300" id="accordion-placeholder-brand" aria-hidden="true" tabindex="-1">Brand</button></h3>
								<div class="c-accordion__content" id="accordion-placeholder-brand-content" aria-labelledby="accordion-placeholder-brand" aria-hidden="true">
									${this.renderPlaceholderItems(5)}
								</div>
						</div>
				</div>
				<div class="mFilter mFilter--placeholder noPrint">
						<div class="inner clearfix ">
								<h3 class="c-accordion__heading"><button type="button" class="c-accordion__title js-slide-toggle" aria-controls="accordion-placeholder-brandrange-content" aria-expanded="false" data-transition-time="300" id="accordion-placeholder-brandrange" aria-hidden="true" tabindex="-1">Brand Range</button></h3>
								<div class="c-accordion__content" id="accordion-placeholder-brandrange-content" aria-labelledby="accordion-placeholder-brandrange" aria-hidden="true">
									${this.renderPlaceholderItems(5)}
								</div>
						</div>
				</div>
				<div class="mFilter mFilter--placeholder noPrint">
						<div class="inner clearfix ">
								<h3 class="c-accordion__heading"><button type="button" class="c-accordion__title js-slide-toggle" aria-controls="accordion-placeholder-finish-content" aria-expanded="false" data-transition-time="300" id="accordion-placeholder-finish" aria-hidden="true" tabindex="-1">Finish</button></h3>
								<div class="c-accordion__content" id="accordion-placeholder-finish-content" aria-labelledby="accordion-placeholder-finish" aria-hidden="true">
									${this.renderPlaceholderItems(5)}
								</div>
						</div>
				</div>
				<div class="mFilter mFilter--placeholder noPrint">
						<div class="inner clearfix ">
								<h3 class="c-accordion__heading"><button type="button" class="c-accordion__title js-slide-toggle" aria-controls="accordion-placeholder-length-content" aria-expanded="false" data-transition-time="300" id="accordion-placeholder-length" aria-hidden="true" tabindex="-1">Length (mm)</button></h3>
								<div class="c-accordion__content" id="accordion-placeholder-length-content" aria-labelledby="accordion-placeholder-length" aria-hidden="true">
									${this.renderPlaceholderItems(5)}
								</div>
						</div>
				</div>
				<div class="mFilter mFilter--placeholder noPrint">
					<div class="inner clearfix ">
						<h3 class="c-accordion__heading"><button type="button" class="c-accordion__title js-slide-toggle" aria-controls="accordion-placeholder-guarantee-content" aria-expanded="false" data-transition-time="300" id="accordion-placeholder-guarantee" aria-hidden="true" tabindex="-1">Guarantee</button></h3>
						<div class="c-accordion__content" id="accordion-placeholder-guarantee-content" aria-labelledby="accordion-placeholder-guarantee" aria-hidden="true">
							${this.renderPlaceholderItems(4)}
						</div>
					</div>
				</div>
			`;
		}
		return html`
			<div class="mFilter mFilter--placeholder noPrint" aria-hidden="true">
					<div class="inner clearfix ">
							<h2 class="title"><span class="inner">Need it fast? </span></h2>
							${this.renderPlaceholderItems(1)}
					</div>
			</div>
			<div class="mFilter mFilter--placeholder noPrint" aria-hidden="true">
					<div class="inner clearfix ">
							<h2 class="title"><span class="inner">Avg. Customer Rating </span></h2>
							${this.renderPlaceholderItems(5)}
					</div>
			</div>
			<div class="mFilter mFilter--placeholder noPrint" aria-hidden="true">
					<div class="inner clearfix ">
							<h2 class="title"><span class="inner">Type </span></h2>
							${this.renderPlaceholderItems(5)}
					</div>
			</div>
			<div class="mFilter mFilter--placeholder noPrint" aria-hidden="true">
					<div class="inner clearfix ">
							<h2 class="title"><span class="inner">Colour </span></h2>
							${this.renderPlaceholderItems(5)}
					</div>
			</div>
			<div class="mFilter mFilter--placeholder noPrint" aria-hidden="true">
					<div class="inner clearfix ">
							<h2 class="title"><span class="inner">Width (mm) </span></h2>
							${this.renderPlaceholderItems(5)}
					</div>
			</div>
			<div class="mFilter mFilter--placeholder noPrint" aria-hidden="true">
					<div class="inner clearfix ">
							<h2 class="title"><span class="inner">Height (mm) </span></h2>
							${this.renderPlaceholderItems(5)}
					</div>
			</div>
			<div class="mFilter mFilter--placeholder noPrint" aria-hidden="true">
					<div class="inner clearfix ">
							<h2 class="title"><span class="inner">Depth (mm) </span></h2>
							${this.renderPlaceholderItems(5)}
					</div>
			</div>
			<div class="mFilter mFilter--placeholder noPrint" aria-hidden="true">
					<div class="inner clearfix ">
							<h2 class="title"><span class="inner">Brand </span></h2>
							${this.renderPlaceholderItems(5)}
					</div>
			</div>
			<div class="mFilter mFilter--placeholder noPrint" aria-hidden="true">
					<div class="inner clearfix ">
							<h2 class="title"><span class="inner">Brand Range</span></h2>
							${this.renderPlaceholderItems(5)}
					</div>
			</div>
			<div class="mFilter mFilter--placeholder noPrint" aria-hidden="true">
					<div class="inner clearfix ">
							<h2 class="title"><span class="inner">Finish</span></h2>
							${this.renderPlaceholderItems(5)}
					</div>
			</div>
			<div class="mFilter mFilter--placeholder noPrint" aria-hidden="true">
					<div class="inner clearfix ">
							<h2 class="title"><span class="inner">Length (mm)</span></h2>
							${this.renderPlaceholderItems(5)}
					</div>
			</div>
			<div class="mFilter mFilter--placeholder noPrint" aria-hidden="true">
					<div class="inner clearfix ">
							<h2 class="title"><span class="inner">Guarantee</span></h2>
							${this.renderPlaceholderItems(4)}
					</div>
			</div>
		`;
	}

	render() {

		return html`
			<div class="js-filter-page js-filter-page--load-initial-from-endpoint js-filter-scroll-after-change js-filter-controls-container">
				<div class="lCols alt clearfix" data-usage-logger-onload="category" id="main-content">

						<div class="col secondary filterSlideOut js-filter-slide-out" id="all-filters-panel">
								<div class="mFilterTopControls">
									<div class="mFilterClear mFilterClearBorder noPrint">
										<button class="primary clearAllFilters u-ty-body-bold" type="button">Clear All <span class="u-visuallyhidden">filters</span></button>
									</div>
									<div class="filterCloseContainer__close">
										<button class="filterCloseContainer__close-link js-filter-slide-close" type="button">Close <span class="u-visuallyhidden">filters</span></button>
									</div>
								</div>
								<div class="filterCloseContainer noDesktop">
										<div class="filterCloseContainer__close">
												<button class="filterCloseContainer__close-link js-filter-slide-close"
														type="button">Close</button>
										</div>
										<div class="filterCloseContainer__reset">
												<button class="filterCloseContainer__reset-link clearAllFilters" type="button">Reset
														All</button>
										</div>
								</div>
								<div class="filterContainer">
										<aside class="filterContent">
												<a href="#product-results"
														class="c-skip c-skip--inline js-ignore-scroll js-filter-skip-to-results">Skip to
														products</a>
												<h2 class="mFilterBy noPrint">Filter by:</h2>
												<p class="mFilterClear noPrint">
														<button type="button" class="primary clearAllFilters u-or-body-bold" id="clearAllFilters"
																data-test="clear-all-filters">Clear all</button>
												</p>

												<form id="filters" action="/btu-calculator?name=${this.search}"
														data-products-json-url="/productsearch/index?name=${this.search}&amp;includeRelevance=False&amp;${this.initialFacets}&amp;pageSize=36"
														data-facets-json-url="/facets/index?name=${this.search}&amp;includeRelevance=False&amp;${this.initialFacets}&amp;pageSize=36"
														method="GET" novalidate="novalidate" data-test="filters-block">
														<input id="term" name="term" type="hidden" value="" />
														<input id="page" name="page" type="hidden" value="1" />
														<input id="sort" name="sort" type="hidden" value="" />
														<div class="filters">
																${this.renderFiltersPlaceholder()}
														</div>
												</form>



												<p class="mFilterClear mFilterClearBorder noPrint">
														<button type="button" class="primary clearAllFilters u-or-body-bold" id="clearAllFiltersBottom"
																data-test="clear-all-filters-bottom">Clear
																all</button>
												</p>

										</aside>

								</div>
								<div class="filterSubmit noDesktop">
										<button type="button" class="formButton filterSubmitButton js-filter-slide-close">Show <b>168</b>
												Products</button>
								</div>



						</div>

						<div class="col primary" id="product-results">

								<div class="filterSlideOutControlsWrapper noDesktop js-filter-slideOut-sticky">
										<div class="filterSlideOutControls js-filter-controls">
												<div class="filterSlideOutControls__sort">
														<label class="u-visuallyhidden" for="PagerSort">Sort products by</label>
														<select id="PagerSort" name="sort" class="c-select">
																<option value="price">Price (low to high)</option>
																<option value="price desc">Price (high to low)</option>
																<option value="rank">Popularity</option>
																<option value="reviewaverage">Customer Rating</option>
														</select>

												</div>
												<div class="filterSlideOutControls__open">
														<button class="openLink js-filter-slide-title u-or-body-bold" type="button">Filter</button>
												</div>
										</div>
								</div>

								<div id="appliedFiltersWrapper">
										<div id="appliedFilters" class="js-applied-filters-container">
												<div class="mFilterTags js-applied-filters-inner">
														<ul class="list">
														</ul>
												</div>
										</div>

								</div>

								<div id="rangeContentWrapper" class="mRange">
										<div class="inner">
												<div class="content clearfix">
														<div class="mPager js-product-pager products clearfix noPrint top js-filter-controls js-load-more-top-pager"
																data-test="top-pager">
																<div class="c-pager clearfix">

																		<form action="?" method="get" novalidate="novalidate" class="c-pager__sort">
																				<div class="c-pager__sort__select clearfix">
																						<label for="PagerSortDesktop" class="c-pager__sort__select__label">Sort<span
																										class="u-visuallyhidden"> results</span> by</label>
																						<select id="PagerSortDesktop" name="sort"
																								class="c-select c-pager__sort__select__element" data-test="pager-sort">
																								<option value="price">Price (low to high)</option>
																								<option value="price desc">Price (high to low)</option>
																								<option value="rank" selected="selected">Popularity</option>
																								<option value="reviewaverage">Customer Rating</option>
																						</select>
																				</div>
																				<noscript>
																						<div class="c-pager__sort__button">
																								<button type="submit" class="c-button">Update</button>
																						</div>
																				</noscript>
																		</form>

																		<p class="c-pager__count" data-test="pager">Showing 1-36 of <span
																						data-test="product-load-more-view-count-total">-</span> products</p>

																</div>

														</div>

														<div class="c-load js-product-load c-load--previous js-load-previous-container"
																data-test="product-load-previous">
														</div>

														<ul class="list clearfix js-product-results-list" data-test="category-results-list">
																<li class="level1 js-placeholder-item">
																		<div class="c-product-card__placeholder"></div>
																</li>
																<li class="level1 js-placeholder-item">
																		<div class="c-product-card__placeholder"></div>
																</li>
																<li class="level1 js-placeholder-item">
																		<div class="c-product-card__placeholder"></div>
																</li>
																<li class="level1 js-placeholder-item">
																		<div class="c-product-card__placeholder"></div>
																</li>
																<li class="level1 js-placeholder-item">
																		<div class="c-product-card__placeholder"></div>
																</li>
																<li class="level1 js-placeholder-item">
																		<div class="c-product-card__placeholder"></div>
																</li>
																<li class="level1 js-placeholder-item">
																		<div class="c-product-card__placeholder"></div>
																</li>
																<li class="level1 js-placeholder-item">
																		<div class="c-product-card__placeholder"></div>
																</li>
																<li class="level1 js-placeholder-item">
																		<div class="c-product-card__placeholder"></div>
																</li>
																<li class="level1 js-placeholder-item">
																		<div class="c-product-card__placeholder"></div>
																</li>
																<li class="level1 js-placeholder-item">
																		<div class="c-product-card__placeholder"></div>
																</li>
																<li class="level1 js-placeholder-item">
																		<div class="c-product-card__placeholder"></div>
																</li>
																<li class="level1 js-placeholder-item">
																		<div class="c-product-card__placeholder"></div>
																</li>
																<li class="level1 js-placeholder-item">
																		<div class="c-product-card__placeholder"></div>
																</li>
																<li class="level1 js-placeholder-item">
																		<div class="c-product-card__placeholder"></div>
																</li>
																<li class="level1 js-placeholder-item">
																		<div class="c-product-card__placeholder"></div>
																</li>
																<li class="level1 js-placeholder-item">
																		<div class="c-product-card__placeholder"></div>
																</li>
																<li class="level1 js-placeholder-item">
																		<div class="c-product-card__placeholder"></div>
																</li>
																<li class="level1 js-placeholder-item">
																		<div class="c-product-card__placeholder"></div>
																</li>
																<li class="level1 js-placeholder-item">
																		<div class="c-product-card__placeholder"></div>
																</li>
																<li class="level1 js-placeholder-item">
																		<div class="c-product-card__placeholder"></div>
																</li>
																<li class="level1 js-placeholder-item">
																		<div class="c-product-card__placeholder"></div>
																</li>
														</ul>
														<div class="c-load js-product-load c-load--more js-load-more-container"
																data-test="product-load-previous">

																<p class="c-load__view-count" data-test="product-load-more-view-count">You've viewed 36
																		of <span data-test="product-load-more-view-count-total">-</span> products</p>


																<p class="c-load__action">
																		<a href="?page=2" class="c-button c-button--secondary c-button--medium js-load-more"
																				aria-label="Load next page of results" data-test="product-load-next">
																				Load More Products
																		</a>
																</p>


														</div>


												</div>
										</div>
								</div>
						</div>

				</div>
			</div>
		`;

	}

}
